import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';

const Banners = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingBannerId, setEditingBannerId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [bannersPerPage, setBannersPerPage] = useState(10);


////////////////////// get token user and pass //////////////////
const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
     const name = decodedToken.name;

const mydb = username.slice(0, 3);

      
//////////////////////


  
  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
 
      const response = await fetch(`/banners?mydb=` + mydb);
      if (!response.ok) {
        throw new Error('Failed to fetch bannersssssss');
      }
      const data = await response.json();
      setBanners(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState(null);

  const openDeleteModal = (bannerId) => {
    setBannerToDelete(bannerId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setBannerToDelete(null);
    setShowDeleteModal(false);
  };

  const handleDelete = async () => {
    if (!bannerToDelete) return;
    try {
      const response = await fetch(`/banners/${bannerToDelete}?mydb=` + mydb, {
        method: 'DELETE',
      });
      if (response.ok) {
        setBanners(banners.filter(banner => banner.id !== bannerToDelete));
        toast.success('Banner deleted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        throw new Error('Failed to delete banner');
      }
    } catch (err) {
      console.error('Error deleting banner:', err);
      alert('Failed to delete banner');
    } finally {
      closeDeleteModal();
    }
  };

  const handleEdit = (banner) => {
    setFormData({
      id: banner.id || '',
      title: banner.title || '',
      slogon: banner.slogon || '',
      banner_url: banner.banner_url || '',
      reference_link: banner.reference_link || '',
    });
    
    setIsEditMode(true);
    setEditingBannerId(banner.id);
    setIsExpanded(true);
    setTimeout(() => {
      document.getElementById('bannerForm').scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const [formData, setFormData] = useState({
    id: '',
    title: '',
    slogon: '',
    banner_url: '',
    reference_link: '',
  });

  const [loadingPhoto, setLoadingPhoto] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoadingPhoto(true);

    const compressedFile = await compressImage(file);
    const formDataFile = new FormData();
    formDataFile.append('file', compressedFile);

    try {
      const response = await fetch('/upload', {
        method: 'POST',
        body: formDataFile,
      });
      if (response.ok) {
        const data = await response.json();
        setFormData(prev => ({
          ...prev,
          banner_url: data.fileUrl,
          banner_url_deletedName: undefined,
        }));
      } else {
        console.error('Upload failed');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingPhoto(false);
    }
  };

  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const maxWidth = 1200;
        const maxHeight = 800;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height *= maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width *= maxHeight / height));
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              reject(new Error('Compression failed'));
            }
          },
          file.type,
          0.7
        );
      };

      img.onerror = (err) => {
        reject(err);
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px'
        }}>
          <a href="/"
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#2980b9';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '18px' }}>←</span>
            Home
          </a>
        </div>
        <div style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Total Banners: {banners.length}
        </div>
      </div>
      <h1 style={{
        color: '#2c3e50',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '2.5rem',
        fontWeight: '300',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>Banners Management</h1>
      
      <div style={{ 
        backgroundColor: 'white',
        borderRadius: '12px', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        marginBottom: '20px'
      }}>
        <button
          onClick={toggleExpand}
          style={{
            width: '100%',
            padding: '20px',
            backgroundColor: isExpanded ? '#3498db' : '#34495e',
            border: 'none',
            textAlign: 'left',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: '600',
            color: 'white',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
          aria-expanded={isExpanded}
          aria-controls="bannerForm"
        >
          <span>Add New Banner</span>
          <span style={{ 
            fontSize: '20px',
            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }}>▶</span>
        </button>
        {isExpanded && (
          <form id="bannerForm" style={{ 
            padding: '30px',
            backgroundColor: '#ffffff'
          }} onSubmit={async (e) => {
            e.preventDefault();
            try {
              const url = isEditMode 
                ? `/banners/${editingBannerId}?mydb=` + mydb
                : '/banners?mydb=' + mydb;
              
              const response = await fetch(url, {
                method: isEditMode ? 'PUT' : 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });
              const data = await response.json();
              
              if (response.ok) {
                toast.success(isEditMode ? 'Banner updated successfully' : 'Banner created successfully', {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                
                setFormData({
                  id: '',
                  title: '',
                  slogon: '',
                  banner_url: '',
                  reference_link: '',
                });
                
                setIsEditMode(false);
                setEditingBannerId(null);
                setIsExpanded(false);
                
                await fetchBanners();
              } else {
                const errorMessage = data.message || (isEditMode ? 'Failed to update banner' : 'Failed to create banner');
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            } catch (error) {
              console.error('Error submitting form:', error);
              toast.error('Error submitting form: ' + error.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Title:</label>
              <input 
                type="text" 
                name="title" 
                value={formData.title} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Slogan:</label>
              <input 
                type="text" 
                name="slogon" 
                value={formData.slogon} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500'
              }}>Reference Link:</label>
              <input 
                type="text" 
                name="reference_link" 
                value={formData.reference_link} 
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  transition: 'border-color 0.3s ease',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ marginBottom: '30px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '15px',
                color: '#2c3e50',
                fontSize: '16px',
                fontWeight: '500'
              }}>Banner Image:</label>
              <div style={{ 
                padding: '20px',
                background: '#f8f9fa',
                borderRadius: '12px',
                border: '2px dashed #dee2e6'
              }}>
                <input
                  type="file"
                  name="banner"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  id="banner_url_input"
                  accept="image/*"
                />
                <label htmlFor="banner_url_input" style={{ cursor: 'pointer', display: 'inline-block', position: 'relative' }}>
                  {loadingPhoto ? (
                    <div style={{
                      width: '40px',
                      height: '40px',
                      border: '4px solid #ccc',
                      borderTop: '4px solid #007bff',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      margin: '0 auto',
                    }} />
                  ) : formData.banner_url ? (
                    <div style={{ 
                      position: 'relative', 
                      display: 'inline-block',
                      maxWidth: '100%',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}>
                      <img 
                        src={formData.banner_url} 
                        alt="Banner preview" 
                        style={{ 
                          maxWidth: '100%',
                          height: 'auto',
                          display: 'block',
                          transition: 'transform 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = 'scale(1)';
                        }}
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          const fileName = formData.banner_url;
                          document.getElementById('banner_url_input').value = null;
                          fetch('/delete-image?mydb=' + mydb, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ fileName }),
                          })
                          .then(response => {
                            if (response.ok) {
                              setFormData(prev => ({ ...prev, banner_url: '', banner_url_deletedName: fileName }));
                              toast.success('Image deleted successfully', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                            } else {
                              throw new Error('Failed to delete image');
                            }
                          })
                          .catch(err => {
                            console.error('Failed to delete image:', err);
                            toast.error('Failed to delete image', {
                              position: "top-right",
                              autoClose: 3000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            });
                          });
                        }}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          backgroundColor: 'rgba(255, 59, 48, 0.9)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          lineHeight: '22px',
                          padding: 0,
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                          '&:hover': {
                            backgroundColor: '#ff3b30',
                            transform: 'scale(1.1)'
                          }
                        }}
                        aria-label="Delete banner"
                      >
                        ×
                      </button>
                    </div>
                  ) : (
                    <div style={{
                      width: '100%',
                      minHeight: '200px',
                      border: '2px dashed #3498db',
                      borderRadius: '12px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px',
                      color: '#3498db',
                      backgroundColor: '#ebf5ff',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(52, 152, 219, 0.15)'
                      }
                    }}>
                      <span style={{ fontSize: '32px', marginBottom: '8px' }}>📷</span>
                      <span style={{ fontSize: '14px', color: '#666' }}>Upload Banner Image</span>
                    </div>
                  )}
                </label>
              </div>
            </div>
            <div style={{ textAlign: 'center', paddingTop: '20px', borderTop: '1px solid #eee', display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                type="submit"
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#27ae60',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 10px rgba(39, 174, 96, 0.3)',
                  minWidth: '150px'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#229954';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 15px rgba(39, 174, 96, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#27ae60';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 10px rgba(39, 174, 96, 0.3)';
                }}
              >
                {isEditMode ? 'Update Banner' : 'Create Banner'}
              </button>
              {isEditMode && (
                <button
                  type="button"
                  onClick={() => {
                    setFormData({
                      id: '',
                      title: '',
                      slogon: '',
                      banner_url: '',
                      reference_link: '',
                    });
                    setIsEditMode(false);
                    setEditingBannerId(null);
                  }}
                  style={{
                    padding: '12px 30px',
                    backgroundColor: '#95a5a6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 10px rgba(149, 165, 166, 0.3)',
                    minWidth: '150px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#7f8c8d';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 15px rgba(149, 165, 166, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#95a5a6';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 10px rgba(149, 165, 166, 0.3)';
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        )}
      </div>
      {/* Banners Table */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        marginTop: '30px'
      }}>
        <h2 style={{
          padding: '20px',
          margin: '0',
          borderBottom: '1px solid #eee',
          color: '#2c3e50',
          fontSize: '1.5rem'
        }}>Banners List</h2>
        
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
        ) : error ? (
          <div style={{ padding: '20px', color: '#e74c3c', textAlign: 'center' }}>{error}</div>
        ) : banners.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#7f8c8d' }}>No banners found</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '14px'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>ID</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Title</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Slogan</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #eee' }}>Reference Link</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #eee' }}>Banner Image</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #eee' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {banners.slice((currentPage - 1) * bannersPerPage, currentPage * bannersPerPage).map((banner) => (
                  <tr key={banner.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{banner.id}</td>
                    <td style={{ padding: '12px' }}>{banner.title}</td>
                    <td style={{ padding: '12px' }}>{banner.slogon}</td>
                    <td style={{ padding: '12px' }}>{banner.reference_link}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      {banner.banner_url && (
                        <img 
                          src={banner.banner_url} 
                          alt={banner.title}
                          style={{ 
                            maxWidth: '100px',
                            height: 'auto',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                          onClick={() => window.open(`/${banner.banner_url}`, '_blank')}
                        />
                      )}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button
                          onClick={() => handleEdit(banner)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#3498db',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#2980b9';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#3498db';
                          }}
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => openDeleteModal(banner.id)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#e74c3c',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#c0392b';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#e74c3c';
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* Pagination Controls */}
        {!loading && !error && banners.length > 0 && (
          <div style={{ 
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            borderTop: '1px solid #eee'
          }}>
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage === 1 ? '#e9ecef' : '#3498db',
                color: currentPage === 1 ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Previous
            </button>
            <span style={{ 
              display: 'flex', 
              alignItems: 'center',
              color: '#2c3e50',
              fontSize: '14px'
            }}>
              Page {currentPage} of {Math.ceil(banners.length / bannersPerPage)}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(banners.length / bannersPerPage)))}
              disabled={currentPage >= Math.ceil(banners.length / bannersPerPage)}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage >= Math.ceil(banners.length / bannersPerPage) ? '#e9ecef' : '#3498db',
                color: currentPage >= Math.ceil(banners.length / bannersPerPage) ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage >= Math.ceil(banners.length / bannersPerPage) ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Next
            </button>
          </div>
        )}
      </div>

      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <h3 style={{ marginBottom: '20px', color: '#e74c3c' }}>Confirm Delete</h3>
            <p style={{ marginBottom: '30px' }}>Are you sure you want to delete this banner?</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c0392b';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#e74c3c';
                }}
              >
                Delete
              </button>
              <button
                onClick={closeDeleteModal}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#7f8c8d';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#95a5a6';
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Banners;
